import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import POReceive from 'components/Po/ListPOReceive';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        {/*<h1>Warehouse</h1>*/}
        <POReceive />
      </SiteContent>
    </ContentLayout>
  );
};
